<template>
  <div class="oneid-callback">
    <div class="oneid-box">
      <b-spinner variant="primary" />
      <p class="mt-3">{{ $t("Loading") || "..." }}</p>
    </div>
  </div>
</template>

<script>
import AccountService from "@/services/account.service";
import ApiService from "@/services/api.service";
import OneIdConfig from "@/plugins/oneid";
import { BSpinner } from "bootstrap-vue";
export default {
  name: "OneIdCallback",
  components: { BSpinner },
  created() {
    const code = this.$route.query.code;
    const state = this.$route.query.state;
    const savedState = sessionStorage.getItem("oneid_state");

    if (!code) {
      this.redirectHomeWithError("OneID code not provided");
      return;
    }
    if (state && savedState && state !== savedState) {
      this.redirectHomeWithError("OneID state mismatch");
      return;
    }
    sessionStorage.removeItem("oneid_state");

    AccountService.SignInOneId({
      code: code,
      redirectUrl: OneIdConfig.redirectUri,
    })
      .then((res) => {
        const data = res.data || {};
        const token = data.auth_token || data.token;
        const user = data.user_info || data.userInfo || data.user;
        if (token) {
          localStorage.setItem("auth_token", token);
        }
        if (user) {
          localStorage.setItem("user_info", JSON.stringify(user));
        }
        ApiService.setHeader();
        this.$router.replace("/cabinet");
      })
      .catch((error) => {
        const data = (error.response && error.response.data) || null;
        this.redirectHomeWithError(this.extractErrorMessage(data));
      });
  },
  methods: {
    extractErrorMessage(data) {
      if (!data) return "OneID login failed";
      if (typeof data === "string") return data;
      if (Array.isArray(data.Message)) return data.Message.join("\n");
      if (typeof data.Message === "string") return data.Message;
      if (Array.isArray(data.message)) return data.message.join("\n");
      if (typeof data.message === "string") return data.message;
      if (data.errors) {
        if (typeof data.errors === "string") return data.errors;
        const errs = Object.values(data.errors).flat();
        return errs.join("\n");
      }
      if (data.title) return data.title;
      return "OneID login failed";
    },
    redirectHomeWithError(message) {
      this.$toast.open({
        message: message || "OneID login failed",
        type: "error",
        duration: 5000,
        dismissible: true,
      });
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.oneid-callback {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.oneid-box {
  text-align: center;
  padding: 32px;
}
</style>
